import Space from "../../Common/Space";
import React, { Fragment } from "react";
import Typography from "@mui/material/Typography";
import {Container, Stack } from "@mui/material";
import Divider from "../../Common/Divider";
import PictureRender from "../../Shared/Pictures/PictureRender";

export function KontaktJagtbasen() {
  return (

    <React.Fragment>
      <Space height="20px" />
      <Container>
        <PictureRender image="logo-round-text" size={150}/>
        <Typography variant="h4">Kontakt Jagtbasen</Typography>
        <Space height="10px"/>
        <Typography variant="h5">Jagtbasen ApS</Typography>
        <Space height="5px" />
        <Divider />
        <Space height="10px" />
        <Stack>

          <Stack direction={"row"}>
            <Typography fontWeight={"bold"}>CVR-nr.:</Typography>
            <Space width="5px" />
            <Typography>43924702</Typography>
          </Stack>
          <Space height="10px" />
          <Typography fontWeight={"bold"}>Adresse:</Typography>
          <Typography>Ny Østergade 9, 1.</Typography>
          <Typography>3600 Frederikssund</Typography>
          <Space height="5px" />
          <Stack direction={"row"}>
            <Typography fontWeight={"bold"}>Email.:</Typography>
            <Space width="5px" />
            <Typography>info@jagtbasen.dk</Typography>
          </Stack>
          <Stack direction={"row"}>
            <Typography fontWeight={"bold"}>Tlf nr.:</Typography>
            <Space width="5px" />
            <Typography>91528585</Typography>
          </Stack>
          <Stack direction={"row"}>
            <Typography fontWeight={"bold"}>Version:</Typography>
            <Space width="5px" />
            <Typography>{process.env.REACT_APP_VERSION}</Typography>
          </Stack>
        </Stack>
      </Container>
    </React.Fragment>
  );
}

